var _style, _g, _path, _path2, _defs, _path3, _path4, _path5, _path6, _path7, _defs2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _g3, _g4, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoBsStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "3710px",
    height: "3710px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4F7FA;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{clip-path:url(#SVGID_00000155108806587997239900000001215362435029974704_);}\n\t.st3{fill:#FCFDFE;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000083776901800582255970000012279181913411783079_);fill:url(#SVGID_00000146495937663740662810000014461683759093033359_);}\n\t.st5{clip-path:url(#SVGID_00000083776901800582255970000012279181913411783079_);}\n\t.st6{fill:url(#SVGID_00000033339755387962290630000006202730787448524172_);}\n\t.st7{fill:url(#SVGID_00000009574024397270083330000001388081834808913546_);}\n\t.st8{opacity:0.5;fill:#D8DEE8;}\n\t.st9{fill:#BFC8D6;}\n\t.st10{fill:url(#SVGID_00000018235457593757740700000001870167649622831538_);}\n\t.st11{fill:url(#SVGID_00000109030001092990429770000005534310009173991562_);}\n\t.st12{fill:url(#SVGID_00000173880816281788330950000006591634280821232271_);}\n\t.st13{fill:url(#SVGID_00000005263993393664872980000014786522617114782852_);}\n\t.st14{fill:url(#SVGID_00000021080451689596267680000002497195729087897021_);}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:url(#SVGID_00000119093186319367911290000016589064255810287016_);}\n\t.st17{fill:url(#SVGID_00000003824354551584228210000001849463737264099491_);}\n\t.st18{opacity:0.3;fill:url(#SVGID_00000108295953274291706650000006150046053413447848_);}\n\t.st19{fill:url(#SVGID_00000030485782696018578310000013009957444931125944_);}\n\t.st20{fill:url(#SVGID_00000045585218968364871890000015626617289660831661_);}\n\t.st21{fill:url(#SVGID_00000072958896655773020790000003005322888489047988_);}\n\t.st22{fill:url(#SVGID_00000047751891151402257330000005909117238371630494_);}\n\t.st23{fill:url(#SVGID_00000139994588339571057830000007783460193062539706_);}\n\t.st24{fill:url(#SVGID_00000029032997789170012920000009679831838571806094_);}\n\t.st25{fill:url(#SVGID_00000116219396381270231580000006605861978334395036_);}\n\t.st26{fill:url(#SVGID_00000025421477994308335960000016211936296366672266_);}\n\t.st27{opacity:0.3;fill:url(#SVGID_00000096034401629934481920000008753501306808568232_);}\n\t.st28{fill:url(#SVGID_00000037663651248933636910000010422956491664941472_);}\n\t.st29{fill:url(#SVGID_00000114791510308401267280000006880009693796267160_);}\n\t.st30{fill:url(#SVGID_00000011023645881067625380000008204844525047142311_);}\n\t.st31{fill:url(#SVGID_00000164512751089589598170000000784215367582228104_);}\n\t.st32{opacity:0.3;fill:url(#SVGID_00000010293287470166568340000012823418522985382820_);}\n\t.st33{fill:url(#SVGID_00000163038138438997617800000008406450984951589525_);}\n\t.st34{fill:url(#SVGID_00000023973657445321501590000007133916873266588311_);}\n\t.st35{fill:url(#SVGID_00000175321846539904639210000005303807451533688246_);}\n\t.st36{fill:url(#SVGID_00000136413746824442338650000003821657505998320009_);}\n\t.st37{fill:url(#SVGID_00000155866415759929311220000008324031103445645734_);}\n\t.st38{fill:url(#SVGID_00000182520308179536648830000016878858817706446751_);}\n\t.st39{fill:url(#SVGID_00000048466766362361408920000007245460367533423506_);}\n\t.st40{opacity:0.3;fill:url(#SVGID_00000082346067423260022310000013622899167967202205_);}\n\t.st41{fill:url(#SVGID_00000062179777338395266850000001814384320090903726_);}\n\t.st42{fill:url(#SVGID_00000039116750779660449720000006452942982904062348_);}\n\t.st43{fill:url(#SVGID_00000171709079750272252860000002480365897287056272_);}\n\t.st44{fill:url(#SVGID_00000075145654330265248500000002517908129515445907_);}\n\t.st45{fill:url(#SVGID_00000091012972448274999390000002687816954701621946_);}\n\t.st46{fill:url(#SVGID_00000113354349951889196550000008095877804567567006_);}\n\t.st47{fill:url(#SVGID_00000119110376326951562260000003187616230264613815_);}\n\t.st48{fill:url(#SVGID_00000141429421220202030390000005447446779159956159_);}\n\t.st49{fill:url(#SVGID_00000013895146004911628200000005411229042049991864_);}\n\t.st50{fill:url(#SVGID_00000066486620571040045590000017380598568052472476_);}\n\t.st51{fill:url(#SVGID_00000053531425585896606890000016385396120186453652_);}\n\t.st52{fill:url(#SVGID_00000006671353860771933190000015647555672510989240_);}\n\t.st53{fill:url(#SVGID_00000013898189550337198810000001627963198486855613_);}\n\t.st54{fill:#26264F;}\n\t.st55{fill:url(#SVGID_00000162311087519818194970000009292403332548238743_);}\n\t.st56{fill:url(#SVGID_00000096034176644334199090000004996669780318926767_);}\n\t.st57{fill:url(#SVGID_00000113348580493263777990000012488760002481673092_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3219.7,1604.5c-78.5-514-400.5-1145.5-1036.6-1211.6c0,0-482.9-58.7-959,30.3 c-282.5,52.8-530.3,210.1-687.1,436.2C380.4,1085.5,328,1361.2,391.5,1624c41.3,170.7,69.2,347.4,61.5,522.7 c-13.3,305.3-5.7,590.2,290.6,772.2c264.5,162.5,597.4,305.9,915,331c215.8,17.1,457.9-10.5,665.9-66.7 C3384.6,2896.9,3298.3,2118.5,3219.7,1604.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -4127.8882,
    y1: -2835.2815,
    x2: -3663.7825,
    y2: 131.6872,
    gradientTransform: "matrix(-0.6654 -0.7465 -0.7465 0.6654 -1586.514 940.047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2119.1,3125.5c-16-5.6-46-31.9-51-42c-33.1-67.1-103.4-188.6-82.5-265c3.6-13,65.1-12.9,75.9-23.3 c39.3-9.4,53.5-10.3,86.4-37.6c97.2-80.6-39.9-299.2,177.5-320.1c159.2-15.4,274.6,62.6,307.3-172.7 c32.7-235.3,305.5-619.2,516.4-405.9c121,122.4-63.1,289.6-21.4,450.3c39.6,152.7-42.9,254.2-207.2,306.2 s-99.3,132.3-84.2,272.7c18.1,168.6-230.5,145.5-344.4,125C2400.1,2996.7,2155.5,3016.6,2119.1,3125.5z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000101790099253289142180000007531667152968767664_",
    d: "M1952.4,2790.7c12.4,116.1,20.3,234.8,32.2,351.8 c63.9,18.9,139.5,39.7,170.7-37.2c43.4-106.9,245.2-109.1,336.8-92.2c113.3,21,362.4,43.5,344.2-124.9 c-15.1-140.2-80.1-220.6,84.2-272.7c164.3-52,246.8-153.5,207.2-306.2c-41.7-160.7,142.4-327.8,21.4-450.3 c-210.8-213.4-483.8,170.9-516.3,405.9c-32.5,235-148.6,158.3-307.2,172.5c-216.5,19.4-82.8,243.6-176.6,318.4 C2075.3,2814.3,2031.8,2791.7,1952.4,2790.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085948171823450150730000017598688681499324290_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101790099253289142180000007531667152968767664_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085948171823450150730000017598688681499324290_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2027.5,2958l-0.9-3.4c271.2-68.1,514.1-217.5,702.6-431.9c179.4-204,307.1-462.7,369.3-747.9l3.4,0.7 c-62.3,285.9-190.3,545-370.1,749.5C2542.9,2740,2299.3,2889.7,2027.5,2958z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2851.8,2957.3c-131.7-76.2-368.2-127.2-527-113.8l-0.3-3.5c159.5-13.5,396.8,37.8,529.1,114.3 L2851.8,2957.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2133.1,2930.2l-1.8-3c71.6-41.7,119.4-118,142.1-226.8c16.6-79.8,19.6-174.8,8.8-282.5l3.5-0.4 c10.8,108.1,7.8,203.5-8.8,283.6C2254,2810.9,2205.6,2888,2133.1,2930.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2756.3,2495l-1.9-2.9c131-85.5,295.4-81.1,410.2-62.4l-0.6,3.5C3049.8,2414.5,2886.3,2410.1,2756.3,2495 z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2953.8,2196.4l-3.4-1c20.9-72.7,40.5-225.2-62.8-429.4l3.1-1.6 C2994.6,1969.8,2974.8,2123.3,2953.8,2196.4z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005260163729092747180000017561047103831808416_",
    d: "M2325.8,3195.1c-86.5-12.7-172.9-27.4-259.1-44.1 c-1.4,1.3-29.7-186.7,59.5-285.3c176.6-191,57.6-362.4,23.7-463.9c-54.3-143.2-26.5-317.3,131.3-284.7 c153.7,28.1,177-288.3,150.5-532c-22.6-118.6,89.3-262.5,201-295.4c114-36.4,227.8,38.1,262.7,274.6 c52.8,273.8-147,438.8-221,576.1c-72.8,134.7,96.5,243.8-39.8,363.1c-114.6,106.1-259.1,182.3-206.3,315.6 C2482.6,2950.9,2469.6,3058.6,2325.8,3195.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127726399598490869160000007455364046739260598_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005260163729092747180000017561047103831808416_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004521421713067955790000004835102824199558800_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.2588,
    y1: -856.4518,
    x2: -542.647,
    y2: 908.2294,
    gradientTransform: "matrix(-0.8674 -0.4976 -0.4976 0.8674 2274.7078 2110.0093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000127726399598490869160000007455364046739260598_)",
      fill: "url(#SVGID_00000004521421713067955790000004835102824199558800_)"
    },
    d: " M2325.8,3195.1c-86.5-12.7-172.9-27.4-259.1-44.1c-1.4,1.3-29.7-186.7,59.5-285.3c176.6-191,57.6-362.4,23.7-463.9 c-53.7-143.1-25.5-298.1,120.2-300.4c161.5-5.7,190.8-273.1,161.5-516.3c-22.6-118.6,89.3-262.5,201-295.4 c114-36.4,227.8,38.1,262.7,274.6c52.8,273.8-147,438.8-221,576.1c-72.8,134.7,96.5,243.8-39.8,363.1 c-114.6,106.1-259.1,182.3-206.3,315.6C2482.6,2950.9,2469.6,3058.6,2325.8,3195.1z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000127726399598490869160000007455364046739260598_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2210.2,3206.3l-3.5-0.1c0-1.7,82.6-397.1,225.1-782c19.7-62.3,41.1-125.2,61.7-186 c55.4-162.8,112.6-331.1,139.8-498.6c30.4-187.3,19.6-356-33.1-515.7l3.3-1.1c52.8,160.3,63.7,329.5,33.2,517.4 c-27.2,167.9-84.5,336.3-139.9,499.2c-20.7,60.8-42,123.6-61.7,186C2291.5,2813.3,2210.4,3204,2210.2,3206.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2596.9,1923.7l-2.6-2.4c96.4-107.1,212.7-259.3,275.2-341.1c50.3-65.8,50.6-65.7,52.7-65.4l-0.5,3.5 l0.3-1.7l0.7,1.6c-2.5,1.8-23.6,29.3-50.3,64.3C2809.8,1664.2,2693.4,1816.5,2596.9,1923.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2626.1,1776.8c-19.9-122.8-70.5-203.5-109.4-249.6c-43-50.9-82.5-73.1-86.6-73.6c0,0,0.4,0,0.8-0.2 l-2-2.9c0.9-0.6,1.9-0.5,4.3,0.6c10.7,4.6,50.6,29.6,92.4,81.6c52.7,65.5,88.6,149.8,103.9,243.7L2626.1,1776.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2350.5,2676l-3.5-0.4c13.6-114.2-13-237.1-79.1-365.1c-34.5-66.8-78.4-132.2-130.6-194.5 c-3.8-4.5-5.1-6.1-5.5-6.8l3-1.8c0.3,0.5,2.5,3.1,5.2,6.3c52.4,62.5,96.5,128.1,131.1,195.1 C2337.4,2437.5,2364.2,2561.1,2350.5,2676z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2389.5,2555.8l-3-1.8c101.8-164.4,314.4-178.6,323.8-178.6c0.2,0,0.3,0,0.3,0l1.3,1.6l-1.2,1.7l-0.6-1.6 l-0.2,1.7c0,0,0,0,0,0C2706.5,2378.8,2491.5,2390.9,2389.5,2555.8z M2709.6,2375.4l0.6,1.7L2709.6,2375.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2224.6,3141.8l-3.5-0.1c1.8-49.7-15.9-134.5-111-255.9c-5.2-6.6-5.2-6.6-5-7.6l3.5,0.5l-1.7-0.3l1.6-0.7 c0.3,0.5,2.2,3,4.4,5.8C2208.6,3005.8,2226.5,3091.5,2224.6,3141.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2246.6,3048.1l-3.4-1c11-37.8,54.1-111.9,219.9-183.3c2.3-1,3.8-1.6,4.3-1.9l1.6,3.1 c-0.6,0.3-2.1,1-4.5,2C2300,2937.9,2257.4,3010.9,2246.6,3048.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116227346909669258360000014940035847279411863_",
    gradientUnits: "userSpaceOnUse",
    x1: 1849.5251,
    y1: 4524.062,
    x2: 1867.8251,
    y2: 2199.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116227346909669258360000014940035847279411863_)"
    },
    d: "M2603.6,3039.8l-381.4,11.8 c-105.3-6.1-226.5-4.2-355.7-0.4c-129.6,3.7-251.8,9.5-358.5,21.8l-391.3,11.6v79.4h0c0,0,0,0.1,0,0.2 c0,50.8,337.9,81.3,751.2,68.5c409.4-12.7,737.7-65.9,736.9-115.8c0-0.2-0.1-3-0.1-3L2603.6,3039.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006688788334148703530000014357507585526295452_",
    gradientUnits: "userSpaceOnUse",
    x1: 1983.1348,
    y1: 2718.5579,
    x2: 1586.9347,
    y2: 3826.1128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006688788334148703530000014357507585526295452_)"
    },
    d: "M2603.6,3040.7 c0.8,49.8-327.3,100.1-736.4,112.4c-412.9,12.4-750.6-18.5-750.6-69.2c0-50.6,337-101,749.1-112.6 C2274,2959.9,2602.8,2991,2603.6,3040.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2123,1868l-189.1,148.7l192.9,143.6c215.4,160,343.5,413.4,347.4,686.5l2.7,187.1c0.1,3.5-3.1,6.5-8.4,10 l-582.7-13.7l-39.3,1.1l-591.6,47.8c-5.5-3.3-7.3-6.1-7.3-9.7l-0.3-189.9c-0.4-277,126.7-539.3,343.3-709.3l191-150.2 l-192.8-143.9c-216.8-161-343.4-414.1-343.7-682.9l-0.3-192.8l587.3,24.9l38.7-0.2l576.8-30.9l2.7,190.2 C2454.3,1449.4,2333.5,1702.3,2123,1868z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M2476.1,3033.8c0,3.5-2.7,7-8,10.5c-47.1,31.1-298,61.2-602.6,70.2c-306.8,9.1-563-6.3-611.9-34.9 c-5.5-3.3-8.4-6.6-8.4-10.2c0-35.1,278.3-71.3,619.3-80.9C2202.9,2978.9,2475.7,2999.2,2476.1,3033.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121983021214294595530000011191416271668145811_",
    gradientUnits: "userSpaceOnUse",
    x1: 1865.0536,
    y1: 1654.7772,
    x2: 1832.8419,
    y2: 4288.1968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121983021214294595530000011191416271668145811_)"
    },
    points: "1875.9,2470 1844.4,2470.7  1840.5,1961.5 1871.8,1961  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003809237250606095430000001937352236527406001_",
    gradientUnits: "userSpaceOnUse",
    x1: 1856.6111,
    y1: 1448.048,
    x2: 1835.0541,
    y2: 3210.4133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003809237250606095430000001937352236527406001_)"
    },
    d: "M1855.5,1661.9l-362.5,4.7l18.9,31.4 c0,0,134.7,192.8,346.2,296.3c208.8-110,338.8-305.3,338.8-305.3l18.1-31.7L1855.5,1661.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143610496173432157620000011234902290366350269_",
    gradientUnits: "userSpaceOnUse",
    x1: 1966.1375,
    y1: 358.7295,
    x2: 1784.6237,
    y2: 2457.4873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143610496173432157620000011234902290366350269_)"
    },
    d: "M2214.9,1651.3 c0.2,19-160.2,36.5-359.2,39.1c-199.9,2.6-362.7-10.7-362.7-29.9c-0.1-19.1,162.5-36.6,362.2-39.1 C2054,1619,2214.7,1632.3,2214.9,1651.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082362587622259311260000015017545922577190551_",
    gradientUnits: "userSpaceOnUse",
    x1: 1859.272,
    y1: 2429.0488,
    x2: 1859.2662,
    y2: 2429.5166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082362587622259311260000015017545922577190551_)"
    },
    d: "M1859.3,2429.2 C1859.1,2429.2,1859.3,2429.1,1859.3,2429.2C1859.3,2429.1,1859.4,2429.1,1859.3,2429.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093872022810070558780000007050009778010980741_",
    gradientUnits: "userSpaceOnUse",
    x1: 1874.1495,
    y1: 2031.3063,
    x2: 1832.2523,
    y2: 5456.5498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093872022810070558780000007050009778010980741_)"
    },
    d: "M2368.2,3036.6 c-179.2,40.1-458.6,52.4-499.3,53.6c0,0-2.7,0.1-4.5,0.1c-1.9,0.1-4.5,0.1-4.5,0.1c-21.6,0.6-111.1,2.1-217.7-1.1 c-94-2.9-201.3-9.4-287.1-23.3c-0.2,0,0.4-0.7,0.4-0.7c0,0,0,0,0-0.1c0-1.2,0-9.3,0-22.3c0,0,0,0,0-0.1 c3.9-66.3,13.6-257.9,47-299.2c39.8-49.2,443.5-305.3,456.9-314.3c13.5,8.4,417.2,244.5,456.9,291.2 c10.7,12.6,19.3,40.7,26.2,74.8c7.9,38.8,13.6,85.8,17.6,128.1C2366.1,2985.2,2368.2,3036.6,2368.2,3036.6z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1511.5,1283.5c-4.3-119.5,6.1-206.3,6.1-206.3s-32.5-75.5-146.9-40.6c-29.9,88.3-41.6,173-40,248.5 L1511.5,1283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1514.2,1336.7l-180.4,1.6c40.4,397,428,624.4,428,624.4l92-1.5C1599.9,1862.1,1529.7,1559,1514.2,1336.7z "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1525.8,3008.2l-163.1,4.6c-21.1-73.1-29.7-146.4-28.6-210.7l183.7-4.8 C1514.6,2916.6,1525.3,3003.6,1525.8,3008.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1520.2,2742.4l-183.1,4.6c38.7-411.5,425.7-654,425.7-654l92.1-1.6 C1601.7,2204.2,1533.9,2513.9,1520.2,2742.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011747048063218499760000013997534269177832116_",
    gradientUnits: "userSpaceOnUse",
    x1: 1920.2186,
    y1: 2110.406,
    x2: 1828.9871,
    y2: 821.7659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011747048063218499760000013997534269177832116_)"
    },
    d: "M2571.6,994.4l-373.3,2.2 c-103.1-8.2-221.7-9.4-348.1-8.7c-126.8,0.6-246.4,3.2-350.8,12.6l-382.8,2.1v72.9h0c0,0,0,1.3,0,1.5 c0,48.6,330.6,86.1,734.9,83.3c400.6-2.8,722-44.1,721.3-91.8c0-0.1,0-0.7-0.1-0.7L2571.6,994.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125565472913988307540000005126865831801570485_",
    gradientUnits: "userSpaceOnUse",
    x1: 1957.5396,
    y1: 680.8015,
    x2: 1592.3514,
    y2: 1701.6641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125565472913988307540000005126865831801570485_)"
    },
    d: "M2571.6,993.9 c0.7,47.7-320.4,88.3-720.7,90.8c-404,2.5-734.3-34.8-734.3-83.3c0-48.4,329.7-89,732.9-90.7 C2249.1,909.1,2570.9,946.3,2571.6,993.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046321989432077186620000016205306253951524542_",
    gradientUnits: "userSpaceOnUse",
    x1: 1867.0939,
    y1: 2607.5139,
    x2: 1847.9412,
    y2: 4173.3228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000046321989432077186620000016205306253951524542_)"
    },
    d: "M2368.2,3036.6 c-179.2,40.1-458.6,52.4-499.3,53.6c0,0-2.7,0.1-4.5,0.1c-1.9,0.1-4.5,0.1-4.5,0.1c-21.6,0.6-111.1,2.1-217.7-1.1 c-94-2.9-201.3-9.4-287.1-23.3c-0.2,0,0.4-0.7,0.4-0.7c0,0,0,0,0-0.1c0-1.2-0.6-9.3-0.1-22.3c100.9,0.1,310.9-7.3,401.9-66.4 c121.4-78.9,222.7-84,355.5-62.5c109,17.6,187.8-43.3,229.7-118.6c7.9,38.8,13.6,85.8,17.6,128.1 C2366.1,2985.2,2368.2,3036.6,2368.2,3036.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160176294786583853560000004483172982082730390_",
    gradientUnits: "userSpaceOnUse",
    x1: -1950.8573,
    y1: 324.2351,
    x2: -1278.4653,
    y2: 780.9538,
    gradientTransform: "matrix(-1 0 0 1 314.5472 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160176294786583853560000004483172982082730390_)"
    },
    d: "M2228.5,567.2 c12.6-8.2,1.1-32.1,0.4-83.3c-0.8-62.8,15.8-74.5,2.4-99.1c-16.4-30.1-57.6-42.6-84.9-43.2c-6-0.1-7.4-3.4-57.9,9.7 c-90.9,23.6-113.7-1.7-154.4,23.5c-39.3,24.4-22.1,51.1-60.3,79.6c-61.9,46.3-127.1-3.8-171.3,35c-41.9,36.6-42.8,130,1.2,181 c49.9,57.8,139.9,40.4,200.3,29c12.7-2.4,76.8-15.9,143.6-65.1c36.9-27.3,62.3-56.4,78.4-77.8c3.8-4.3,9.7-9.4,17.5-10.3 c9.4-1,16.9,4.7,20.5,7.2C2182.9,566.5,2216,575.2,2228.5,567.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016791733451402375850000017587921923790480288_",
    gradientUnits: "userSpaceOnUse",
    x1: 2307.7051,
    y1: 102.9716,
    x2: 2321.9622,
    y2: 1906.584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016791733451402375850000017587921923790480288_)"
    },
    d: "M2142.9,503.4 c16.3-14.8,109,17.3,147.5,55.2c45.2,44.5,41.7,80.6,81.2,136c19.6,27.5,53.2,64.5,112.8,97c-4.2,10.5-8.4,21.1-12.6,31.6 c-28.8,1.7-85.3,0.7-138.1-33.7c-36.6-23.9-55.5-55.6-91.7-118C2205.6,608.7,2122.6,522,2142.9,503.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039132641734997571030000016254343570333880983_",
    gradientUnits: "userSpaceOnUse",
    x1: -1690.2662,
    y1: 192.2695,
    x2: -1591.4502,
    y2: 192.2695,
    gradientTransform: "matrix(-0.831 -0.5562 -0.5562 0.831 1250.5945 279.3084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039132641734997571030000016254343570333880983_)"
    },
    d: "M2532.9,1368.9l-18.5-39.3 c-2.6-5.6-6.7-10.3-11.9-13.8l-9.2-6.1c0,0-21.9-0.6-25.3,13.2c-0.7,17.5,33.2,56.5,54.7,72c3.6,2.6,8.6,6,11.7,4.2 C2539.7,1396.1,2536.1,1380,2532.9,1368.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102526447172802799730000009252690025216480422_",
    gradientUnits: "userSpaceOnUse",
    x1: -2206.7732,
    y1: 1401.1299,
    x2: -2045.5237,
    y2: 917.3799,
    gradientTransform: "matrix(-1 0 0 1 314.5472 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102526447172802799730000009252690025216480422_)"
    },
    d: "M2498.1,1288.3 c-2.9,16.9,0.8,25.6,4.7,30.6c2.8,3.5,25.5,40.9,16.2,46.9c-4.2,2.7-33-33.1-35.8-38.5c-2.5-5-4.2-3.8-4.3-17.3 c-0.1-8.9-1.9-16.1-3.3-20.6C2483.1,1289,2490.6,1288.6,2498.1,1288.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174561156349308980460000016072087951332230835_",
    gradientUnits: "userSpaceOnUse",
    x1: -2233.8105,
    y1: 1178.9865,
    x2: -2178.4299,
    y2: 1178.9865,
    gradientTransform: "matrix(-1 0 0 1 314.5472 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174561156349308980460000016072087951332230835_)"
    },
    d: "M2530.9,1154.7c0,0,20.5,24.4,17.1,51.2 c-3.3,26.8-39.2-12.4-44.2-25.6c-5-13.2-10.8-32.1-10.8-32.1S2518.1,1132.6,2530.9,1154.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122694138510376018160000011720899167633964448_",
    gradientUnits: "userSpaceOnUse",
    x1: -2265.9072,
    y1: 1331.0507,
    x2: -2175.4773,
    y2: 1059.7594,
    gradientTransform: "matrix(-1 0 0 1 314.5472 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122694138510376018160000011720899167633964448_)"
    },
    d: "M2523,1116.5c0,0-5.6,28.5,5,43.5 c5.3,7.5,12.4,13.8,10.3,19.9c-1.4,4.1-6.7,7-11.2,6.5c-8.6-0.9-13.4-14.1-16.8-23.5c-5-13.8-7.8-43.3-7.8-43.3L2523,1116.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078010801513400971660000005420051170878379151_",
    gradientUnits: "userSpaceOnUse",
    x1: -8618.0068,
    y1: 4657.8438,
    x2: -8177.3911,
    y2: 4408.3779,
    gradientTransform: "matrix(-1 0 0 1 314.5472 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078010801513400971660000005420051170878379151_)"
    },
    d: "M2506.7,1140.5 c6.3-2.3,12.6-4.6,18.9-6.9c9.8-22.4,21.8-59.3,17.8-104.1c-10.3-115.2-116.8-176.2-128.6-182.7c-29,14.6-58.4,35.1-59.5,61 c-1.3,32.5,42.9,49.7,84.6,97.2C2464.9,1033.6,2491.6,1076.1,2506.7,1140.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132784056899655538210000002592306630297661119_",
    gradientUnits: "userSpaceOnUse",
    x1: 2117.6895,
    y1: 732.3926,
    x2: 2231.0833,
    y2: 1215.126,
    gradientTransform: "matrix(1 0 0 1 84.2618 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132784056899655538210000002592306630297661119_)"
    },
    d: "M2499.9,1301.5 c20.8-81.3,15.5-147.6,9.5-185.8c-9.1-57.7-27.5-175.2-105.9-219c-17.1-9.6-41.6-18.1-71.4-44.7c-24.9-22.2-40.7-45.5-50.3-62 c-104.9-30.8-201.6-18.3-244.2,37.9c-4.9,6.5-17.3,20.6-19.7,41.4c-5.4,46.9,40.7,103.3,92.4,115.1c65.7,15,103.8-52.5,162-30 c16.3,6.3,30.1,21.8,57.7,53c35.1,39.6,54.9,76.1,62.3,90.7c22.2,43.5,39.1,75.7,41.6,117.3c0.6,9.7,0.9,29.3,12.3,50.4 c8.7,16.2,20.5,27,29.3,33.7C2483.7,1300.2,2491.8,1300.9,2499.9,1301.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089563237610426477750000007845355436493599385_",
    gradientUnits: "userSpaceOnUse",
    x1: -2059.2168,
    y1: 1336.1337,
    x2: -1963.3107,
    y2: 1032.6068,
    gradientTransform: "matrix(-1 0 0 1 314.5472 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000089563237610426477750000007845355436493599385_)"
    },
    d: "M2017.9,869.4 c2.4-20.8,14.7-34.9,19.7-41.4c42.7-56.2,139.4-68.7,244.2-37.9c9.6,16.4,25.4,39.8,50.3,62c29.8,26.6,54.3,35.1,71.4,44.7 c47.9,26.7,73.4,80.9,88.1,132.2c-21.8-33.8-40.4-42.7-54.9-42.9c-20.7-0.2-29.9,17.4-54.5,15c-26.4-2.6-32.4-24.4-53.7-26.9 c-6.4-0.7-14.3,0.2-23.7,5.3c-12.6-13.2-22-21-32.4-25c-58.2-22.4-96.3,45-162,30C2058.6,972.7,2012.5,916.3,2017.9,869.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049923769968606849350000005094914941957359493_",
    gradientUnits: "userSpaceOnUse",
    x1: -8593.6396,
    y1: 4700.8672,
    x2: -8153.0244,
    y2: 4451.4014,
    gradientTransform: "matrix(-1 0 0 1 314.5472 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049923769968606849350000005094914941957359493_)"
    },
    d: "M2445.6,933.1 c-11.9-0.6-30.1-1-52.2,1.2c-104.6,10.3-133.5,62.1-219.9,74.7c-20.5,3-111.5,16.3-151-36.4c-28.3-37.8-24-102.9,6.9-128.5 c13.1-10.8,26.1-10.5,110-9.8c31.6,0.3,63.2,0.4,94.9,0.8c133.8,1.7,159.4-7.6,183.8,14.6C2429.5,860,2446.1,882.2,2445.6,933.1z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158007413615041529790000004056841575737286790_",
    gradientUnits: "userSpaceOnUse",
    x1: 2130.967,
    y1: 103.4215,
    x2: 2145.0715,
    y2: 1887.7222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158007413615041529790000004056841575737286790_)"
    },
    d: "M2163.1,503.7 c0,0-105.6-30.8-152.2,21.9c-8.5,9.7-15.3,22.4-20.2,46.9c-25,125.1,69.7,200.2,32.4,266.2c-14.8,26.2-40.9,34.1-59.5,81.2 c-3.1,8-14.5,36.8-4.1,45.9c9.2,8,24.3-8.9,51.1-5.6c28.4,3.5,35,25.3,54.1,22.1c12.5-2.1,17.8-12.7,36.2-39.2 c26.6-38.4,39.8-57.6,49.4-64.3c37.6-26.6,66.6,8.1,109.5-18.2c15.5-9.5,73-83.5,56.1-63.2c-40.2-50.2-49.6-91.6-50.6-120.4 c-1.1-31.6,8-45.9,0-83.2c0,0-1.7-19.6-34.1-55.4C2226.5,533.1,2213.7,505.7,2163.1,503.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140721848959906071020000009205838195400931752_",
    gradientUnits: "userSpaceOnUse",
    x1: 3644.4092,
    y1: 166.2805,
    x2: 3650.3752,
    y2: 7.3673,
    gradientTransform: "matrix(0.984 0.1784 -0.1784 0.984 -1433.8892 -244.2395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140721848959906071020000009205838195400931752_)"
    },
    d: "M2120.3,443.3c1.2,5.8,7.6,36.9-5.2,45 c-2.8,1.7-8.1,2.7-18.7,4.7c-6.9,1.3-12.8,2.1-16.9,2.6c0.6,5.2,2.4,13.7,8.4,21.4c16.9,21.7,50.8,16.1,55.6,15.2 c17-3.1,33.8-8.4,37.8-11.6c6.2-4.9,11-8.6,13.9-12.3c-6.6-3.2-19.9-11.6-28.8-14.3c-6.7-2.1-12.9-3.5-18.6-4.6 c-0.9-6-1.9-12-2.8-18C2136.8,462,2128.6,452.7,2120.3,443.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132776436844096696030000012225535546753417633_",
    gradientUnits: "userSpaceOnUse",
    x1: 3642.5471,
    y1: 25.9913,
    x2: 3639.9934,
    y2: 231.7412,
    gradientTransform: "matrix(0.984 0.1784 -0.1784 0.984 -1433.8892 -244.2395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132776436844096696030000012225535546753417633_)"
    },
    d: "M2119.7,458.9c0,0,2.3,22.8,24.5,26.8 c19.9,3.6,34.8-44.4,24.6-56.8c-3.4-4.1-11.8-8.1-19-7.9c-5.1,0.1-22.3,6.7-24.7,24c-3.4-3.6-7.7-4.7-9.8-3.1 c-2.7,1.9-1.2,7.5-0.9,8.8C2115.5,455,2118.4,457.7,2119.7,458.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116915602265829251540000013805545949597297043_",
    gradientUnits: "userSpaceOnUse",
    x1: 1870.9487,
    y1: 822.1104,
    x2: 2234.6377,
    y2: 822.1104,
    gradientTransform: "matrix(1 0 0 1 84.2618 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000116915602265829251540000013805545949597297043_)"
    },
    d: "M2315.8,797.3 c-4.8-6-9.2-11.9-13.2-17.7c-22.2-7.4-41.4-10.2-56.9-11c-34.9-1.7-54.1,6.5-77.9-7.8c-27-16.2-22.2-38.8-48.3-51.4 c-27.4-13.2-46.8,1.7-73.2-3.1c-15.9-2.9-35.3-13.6-55.1-44.6c15.2,74.8,59.3,128.4,31.8,177c-14.8,26.2-40.9,34.1-59.5,81.2 c-3.1,8-14.5,36.8-4.1,45.9c9.2,8,24.3-8.9,51.1-5.6c28.4,3.5,35,25.3,54.1,22.1c12.5-2.1,17.8-12.7,36.2-39.2 c26.6-38.4,39.8-57.6,49.4-64.3c37.6-26.6,66.6,8.1,109.5-18.2C2275.3,851,2332.7,777,2315.8,797.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046305989684292185730000006810746394371582641_",
    gradientUnits: "userSpaceOnUse",
    x1: 1963.0575,
    y1: 829.5488,
    x2: 2224.3176,
    y2: 829.5488,
    gradientTransform: "matrix(-1 0 0 1 4317.1064 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046305989684292185730000006810746394371582641_)"
    },
    d: "M2347.7,810.1l-239,11.6 c-3.3,0.2-6.3,1.9-8,4.7l-6.6,10.6c-3.3,5.3,0.7,12.1,6.9,11.9l253.2-9.6L2347.7,810.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050660810922081738860000012270373013110681776_",
    gradientUnits: "userSpaceOnUse",
    x1: 1712.3113,
    y1: 759.8799,
    x2: 2070.9106,
    y2: 759.8799,
    gradientTransform: "matrix(-1 0 0 1 4317.1064 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050660810922081738860000012270373013110681776_)"
    },
    d: "M2596.3,677l-246.9,4.8 c-7.3,0.1-14,4.1-17.6,10.5l-85.5,150.5l260.8-10.4c7.2-0.3,13.7-4.2,17.4-10.3l79.2-132.4C2607,684,2602.8,676.9,2596.3,677z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118376958622435331970000005828488182739352459_",
    gradientUnits: "userSpaceOnUse",
    x1: 1787.5229,
    y1: 762.2211,
    x2: 2070.9106,
    y2: 762.2211,
    gradientTransform: "matrix(-1 0 0 1 4317.1064 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118376958622435331970000005828488182739352459_)"
    },
    d: "M2331.7,692.3 c3.6-6.4,10.3-10.3,17.6-10.5l5.4-0.1c0.8,8,3.3,15.3,8.1,21.2c15.2,18.4,40.5,7,59.4,26.5c20.7,21.4,1.6,46.8,20.1,66.7 c19.5,20.9,51,3.9,87.2,17.3l-5.2,8.7c-3.7,6.1-10.2,10-17.4,10.3l-260.8,10.4L2331.7,692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048466110175024317280000009894952416678382769_",
    gradientUnits: "userSpaceOnUse",
    x1: 2001.2209,
    y1: 104.4473,
    x2: 2015.3254,
    y2: 1888.7457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048466110175024317280000009894952416678382769_)"
    },
    d: "M2128.1,802.1 c3.1-8.2,6.2-16.4,9.3-24.6c-34.4-9.4-81.9-23.4-130.7-40.8c-7.6-2.7-16.7-6.1-19.7-14.2c-8.3-22.5,44.7-45.9,65.3-95.2 c19.1-45.5,8.6-108.7-13.6-116.2c-46-15.5-209.3,187.7-151,273.4C1920.7,833,2022.4,840.7,2128.1,802.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150071528041022329460000013893394400365684393_",
    gradientUnits: "userSpaceOnUse",
    x1: 2106.1738,
    y1: 778.0316,
    x2: 2019.3265,
    y2: 859.8742,
    gradientTransform: "matrix(1 0 0 1 84.2618 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150071528041022329460000013893394400365684393_)"
    },
    d: "M2137.4,777.5 c21.6-11.5,47.4,0.3,49.1,1.1c4.7,2.2,11.6,6.2,18.6,13.4c0.8,1.1,10.2,14.1,6.7,18.2c-2.7,3.3-13.3,0.6-26.1-7.3 c-5.3-0.7-13.3-1.4-22.8-0.6c-17.5,1.6-25.5,7.1-31.8,2.4c-4.6-3.5-6.2-10.9-4.6-16.3C2128.5,782.4,2133.8,779.4,2137.4,777.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137120449411490198950000006606591159541439365_",
    gradientUnits: "userSpaceOnUse",
    x1: 683.041,
    y1: 1284.6968,
    x2: 943.3185,
    y2: 1703.1545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137120449411490198950000006606591159541439365_)"
    },
    d: "M1162.9,1384.4v291.4 c0,42.2-35.2,76.2-78.9,76l-162.3-0.7l-21.4-0.1l-75.7,92.8c-5.7,4.5-19.5,4.7-24.1-0.9l-11.2-14.8l-58.8-77.7l-5.4,0 l-148.4-0.6c-16-0.1-29.6-5.9-41.1-15.5c-15.1-12.7-23.9-32.2-23.9-53.9V1416c0-38.2,28.8-71,65.9-73.2l31.5-1.9l475.8-28.2 c11.9-0.7,22.6,1.2,32.8,5.2C1144.7,1328.5,1162.9,1353.8,1162.9,1384.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103970066596100209720000002857984448280232889_",
    gradientUnits: "userSpaceOnUse",
    x1: 671.7927,
    y1: 1278.0842,
    x2: 931.1778,
    y2: 1695.1071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103970066596100209720000002857984448280232889_)"
    },
    d: "M1151.3,1376.9v290.6 c0,42-36.4,76-79.8,75.9l-153.5-0.3l-30.2-0.1l-75.3,88.5c-5.5,6.4-15.2,6.4-20.5-0.1l-2.8-3.3l-64.2-77.8l-6.4-7.7l-153-0.3 c-11.2,0-21.2-2.9-30.5-8c-21.2-11.6-35-34.6-35-61.2v-263.6c0-38.1,29.1-70.9,66-73.1l36.1-2.2l468.7-28.6 c17.7-1.1,34.8,3.6,48,12.3C1138.1,1330.6,1151.3,1352,1151.3,1376.9z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M785.9,1587.5l26.3-0.6c7.3-0.2,13.4-6.4,13.8-13.8l9.6-185.2c0.2-3.8-1.2-7-3.8-9.5 c-2.6-2.6-6.2-3.4-10-3.1l-45.3,3.2c-3.7,0.3-7.3,1.5-9.8,4.4c-2.5,2.9-3.9,6.4-3.7,10.1l9.4,181.8 C772.8,1581.9,778.7,1587.7,785.9,1587.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M826.5,1632.7c-6.6-6.3-15.8-9.3-27.7-9.1c-12.2,0.2-21.5,3.4-27.9,9.7c-6.3,6.2-9.5,15.3-9.5,27.3 c0,11.6,3.2,20.5,9.7,26.8c6.5,6.4,15.7,9.5,27.7,9.5c11.7,0,20.9-3.3,27.6-9.9c6.7-6.6,10-15.7,10-27.1 C836.4,1648.1,833.1,1639,826.5,1632.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126323094221850436480000003484336568696901277_",
    gradientUnits: "userSpaceOnUse",
    x1: 500.3474,
    y1: 1383.1881,
    x2: 736.1743,
    y2: 1762.3357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000126323094221850436480000003484336568696901277_)"
    },
    d: "M922,1751.2l-21.6-0.1 l-75.8,92.8c-5.7,4.5-19.5,4.7-24.2-0.9l-11.3-14.8l-64.2-77.8l-148.4-0.6c-16-0.1-30-5.9-41.5-15.5c-21.2-11.6-35-34.6-35-61.2 v-263.6c0-38.1,29.1-70.9,66-73.1l36.1-2.2c2.3,2.2,4.3,4.4,6.5,6.8c24.2,26.6,41.3,65.9,38.2,123.8 c-9.2,172.1,105.2,200,208.5,232.3c32,10,51.2,27.2,62.3,46.1C919.3,1745.8,920.7,1748.5,922,1751.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096759442047783656660000015370655564419955114_",
    gradientUnits: "userSpaceOnUse",
    x1: -980.1251,
    y1: 2411.1377,
    x2: -1050.3508,
    y2: 2487.0139,
    gradientTransform: "matrix(-0.127 -0.9919 -0.9919 0.127 3033.6333 714.7271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096759442047783656660000015370655564419955114_)"
    },
    d: "M763.4,2003.5l14.8-21.2l30.2-12.5 c0,0-12.1-22.1-40.1-5.6c-8.8,9.4-21.1,31.1-34.4,41.4C720.7,2016,763.4,2003.5,763.4,2003.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072238547058088027850000012324677098038413226_",
    gradientUnits: "userSpaceOnUse",
    x1: 808.7822,
    y1: 1172.9706,
    x2: 710.0096,
    y2: 2451.0366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072238547058088027850000012324677098038413226_)"
    },
    d: "M654.1,2019.2 c30.9-33.8,67.8-50.8,87.4-58.4c6,2.5,15.2,7.3,21,16.7c25.2,40.9-54.3,103.8-35,144c12.8,26.8,53.2,9.4,105.3,53.9 c25,21.4,27.3,35.3,24.2,45.7c-4.8,16.4-24.1,27.4-30,30.8c-51,29.2-156.8,21.2-201.5-43.4 C588.1,2154.3,603.4,2074.7,654.1,2019.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170990908423916903060000014124234206415903405_",
    gradientUnits: "userSpaceOnUse",
    x1: 954.5145,
    y1: 3131.7664,
    x2: 992.8991,
    y2: 3165.9097,
    gradientTransform: "matrix(-0.9902 -0.14 -0.14 0.9902 2088.2761 206.9384)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170990908423916903060000014124234206415903405_)"
    },
    d: "M693.9,3191.7 c-1.1-6-20.5-11.5-30.1-3.4c-4.8,4-8.1,12.1-5.3,15.8c1,1.3-3.1,3.7,0.8,3.7C672.3,3208,695,3197.7,693.9,3191.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111168057586214285210000012775306645054233494_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.2234,
    y1: 3165.957,
    x2: 66.2234,
    y2: 3099.0876,
    gradientTransform: "matrix(-0.9902 -0.14 -0.14 0.9902 1172.075 77.4224)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111168057586214285210000012775306645054233494_)"
    },
    d: "M673.5,3193.9l-20-2.8 c9.3-11.1,7.5-46.6,7.5-46.6l21.3,4.7c0,0-2.4,9.7-6.5,24.1C674.4,3178.2,673.7,3185.9,673.5,3193.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039831583541820312030000005365259079037627838_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.3735,
    y1: 3127.429,
    x2: 996.7578,
    y2: 3161.572,
    gradientTransform: "matrix(-0.9902 -0.14 -0.14 0.9902 2088.2761 206.9384)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039831583541820312030000005365259079037627838_)"
    },
    d: "M675.3,3191.5c0,0-24.1-5.5-26.7-0.8 c-2.6,4.8-4.6,17.6,10.6,17.1C674.5,3207.4,676.6,3195.5,675.3,3191.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132086259478099160750000007943881894651256713_",
    gradientUnits: "userSpaceOnUse",
    x1: 1009.0791,
    y1: 3195.6052,
    x2: 1047.4653,
    y2: 3229.75,
    gradientTransform: "matrix(-1 0 0 1 1985.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132086259478099160750000007943881894651256713_)"
    },
    d: "M968.1,3214.3 c-1.9-5.8-21.9-8.5-30.3,0.8c-4.2,4.6-6.3,13.1-3,16.4c1.2,1.2-2.6,4.1,1.3,3.6C949.1,3233.4,970,3220.1,968.1,3214.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061431391173964982470000001098291819140550282_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.7445,
    y1: 3229.8181,
    x2: 120.7445,
    y2: 3162.9458,
    gradientTransform: "matrix(-1 0 0 1 1060.123 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061431391173964982470000001098291819140550282_)"
    },
    d: "M948.2,3219.3h-20.2 c7.6-12.3,0.9-47.2,0.9-47.2l21.7,1.7c0,0-1,10-3.1,24.8C946.9,3203.7,947.3,3211.4,948.2,3219.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074423036209005647320000015601972169017154230_",
    gradientUnits: "userSpaceOnUse",
    x1: 1232.8425,
    y1: 3260.4834,
    x2: 982.537,
    y2: 2249.8777,
    gradientTransform: "matrix(1 0 0 1 -290.3139 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074423036209005647320000015601972169017154230_)"
    },
    d: "M1000.5,2456 c9.3,30.9,22.7,80.7,31.3,143.2c24.5,178.3-27.6,184-17.9,381.6c3.1,63.1-54.6,208.5-59.7,211.8c-2.5,0.2-5.1,0.4-8,0.3 c-5-0.2-12.1-0.9-20.3-3.4c-9.1-1.6-42.1-90.9-34.5-144c5.4-37.6,3.8-77.9,0.7-158.6c-0.5-13.1-34-254.4-34-254.4 c-10.2,89.3-21.9,165.2-32,224.1c-32.6,189.1-138.6,303.5-144.1,305.3c-1.1,0.4-11,4.1-19.2-1.3c-3.6-2.4-4.9-5.5-4.9-5.5 c-2.8-2.2,0.8-188.8,33.2-329.1c46.9-203.8,26.5-251.4,41.4-342.4C745.4,2404.8,1000.5,2456,1000.5,2456z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119823139429996672890000014664970192854053037_",
    gradientUnits: "userSpaceOnUse",
    x1: 944.0221,
    y1: 1166.8524,
    x2: 845.2497,
    y2: 2444.9158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119823139429996672890000014664970192854053037_)"
    },
    d: "M1013.1,2486.8 c-28.2,14.5-100.7,40.4-187.2,27.5c-39.5-5.9-71.1-19-93.3-30.8c22.4-67.9,4.8-104.3-3.5-137.8c-11.8-47.8-12-44.2-21.8-82.1 c-16.1-62.6-18.7-126.7-7.7-139.7c23-27.3,60.3-34.3,88.9-36.4c8.4-0.6,16.1-0.9,22.5-1c15.9-0.5,42.5-3.6,69.9-1.8 c26.1,1.8,53,8,72.2,25.4c0.7,0.6-7.4,4.9-3.4,9.6c3.7,4.4,16.3,19.5,27.8,40c8.4,14.9,15.8,32.1,23.4,57.9 c13.3,45.4,17.2,84.1,18.5,101C1026.8,2413.3,1019.6,2457.1,1013.1,2486.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111189380508852182060000017316405486363648694_",
    gradientUnits: "userSpaceOnUse",
    x1: 1012.9388,
    y1: 3191.2681,
    x2: 1051.3242,
    y2: 3225.4119,
    gradientTransform: "matrix(-1 0 0 1 1985.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111189380508852182060000017316405486363648694_)"
    },
    d: "M949.6,3216.6c0,0-24.6-2.1-26.5,3 c-1.9,5.1-2.1,18,12.9,15.5C951.1,3232.6,951.6,3220.5,949.6,3216.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008109015989973994770000011892383631524575635_",
    gradientUnits: "userSpaceOnUse",
    x1: -92.6813,
    y1: 1401.4462,
    x2: -145.4721,
    y2: 1486.843,
    gradientTransform: "matrix(-0.9717 -0.2361 -0.2361 0.9717 1065.225 640.4756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008109015989973994770000011892383631524575635_)"
    },
    d: "M831.5,2042c-4.4-2.6-7.8,3-5.7,8 c2.1,5,9.1,8.1,13.3,5.1C843.3,2052.2,837.4,2045.6,831.5,2042z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034810915244448650420000003270031988768601007_",
    gradientUnits: "userSpaceOnUse",
    x1: 824.2305,
    y1: 1981.431,
    x2: 874.3226,
    y2: 2433.2222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034810915244448650420000003270031988768601007_)"
    },
    d: "M886.2,2091.7 c0,8.6-22.3,15.5-49.8,15.5c-27.5,0-49.7-7-49.7-15.5c0-1.4,0.6-2.8,1.8-4.1c8.4-0.6,16.1-0.9,22.5-1c15.9-0.5,42.5-3.6,69.9-1.8 C884.3,2086.8,886.2,2089.2,886.2,2091.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102538315726423359960000010503049498683085244_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.1501,
    y1: 1981.6616,
    x2: 872.2422,
    y2: 2433.4534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102538315726423359960000010503049498683085244_)"
    },
    d: "M849.8,2085c-2.9-6.5-5.8-13-8.6-19.4 c2.5-2.5,19-14.8,18.7-28.8c-0.5-19-15.5-33.4-18.5-36.3c-12.4-12.2-15-13.5-19.6-14.9l-6.2-1.6c0,0-0.3,0-0.7,0 c-3.7-0.2-15.3,3-17.5,4.2c-6.9,3.9-5.5,36.5,9.8,78.5c0.2,1.7,0.4,3.5,0.6,5.2c1.4,10.9,3.2,21.2,5.4,31.1 C813.3,2103,841.6,2104.2,849.8,2085z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M834.2,1977.5c4,13.2-4.9,18.9-7.4,22.2c-0.3,0.4-2.1,3-3.2,6.7c-0.2,0.5-0.2,1.1-0.3,1.8 c-0.3,9.2,15.9,15,14.5,19.5c-1,3.3-11.2,2.4-11.5,5.1c-0.3,2.5,8.6,4.8,8.2,7.8c-0.3,2.3-5.4,1.9-7.4,5.8c-1,2-0.2,3-0.3,8.2 c-0.1,2.9-0.4,6.1-0.8,8c-2.2,9.2-14.3,16-17.7,13.6c-1-0.7-0.6-1.6-2.2-4.3c0,0-1.5-2.5-4.3-5c-4-3.6-11.5-4.8-19.5-7.5 c-14.8-5-20.3-11.4-22.1-13.6c-0.6-0.8-1-1.4-1.4-1.8c-6.1-8.8-10.6-23.1-8.9-33.3c2.8-17,21.5-15.1,30.6-33.9 c5.1-10.5,8.1-21.5,20.3-25.8c9.5-3.4,18.2,0,23.9,8.1C828.6,1964.4,832.3,1971.3,834.2,1977.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168103683649921537820000005703472249718207397_",
    gradientUnits: "userSpaceOnUse",
    x1: 826.821,
    y1: 1981.1438,
    x2: 876.9133,
    y2: 2432.936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168103683649921537820000005703472249718207397_)"
    },
    d: "M832.2,2026c-4.6-3.5-9,2.5-7.3,8.3 c1.7,5.8,9.2,10.1,14.2,7.3C844.2,2038.7,838.4,2030.7,832.2,2026z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070811995651242592400000003701649003227326087_",
    gradientUnits: "userSpaceOnUse",
    x1: 1771.7833,
    y1: 1331.0394,
    x2: 1819.2252,
    y2: 1371.4292,
    gradientTransform: "matrix(0.9067 -0.4217 0.4217 0.9067 -1359.3041 1493.8378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070811995651242592400000003701649003227326087_)"
    },
    d: "M874.6,1957.4l-20.5-12.6 c0,0-19-8.6-39.8,5.1c-20.8,13.7-11.9,23.6-11.9,23.6l15.3-6.9c0,0,9.9-4.5,25.1,2.2c17.6,5.1,29.9,3.8,29.9,3.8L874.6,1957.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120534256841110839710000017404811020827215233_",
    gradientUnits: "userSpaceOnUse",
    x1: 1036.9039,
    y1: 1174.0305,
    x2: 938.1313,
    y2: 2452.0972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120534256841110839710000017404811020827215233_)"
    },
    d: "M970.4,1939.5 c-43.4-14.6-84-11.6-104.8-8.7c-4,5.1-9.8,13.8-10.3,24.8c-2.2,48,97.8,64.4,100.4,109c1.8,29.7-42,34-66,98.2 c-11.5,30.8-6.8,44.1,0.9,51.7c12.2,12,34.4,12.3,41.2,12.4c58.7,0.8,147.4-57.5,155.2-135.7 C1093.6,2025.8,1041.7,1963.5,970.4,1939.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoBsStatus);
export default __webpack_public_path__ + "static/media/JOBs_status.bad79aa4.svg";
export { ForwardRef as ReactComponent };